var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOracleSql(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40.331,
    height: 25.504,
    viewBox: "0 0 10.671 6.748",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.375 6.748A3.373 3.373 0 010 3.377 3.377 3.377 0 013.375 0h3.922a3.376 3.376 0 013.374 3.377 3.372 3.372 0 01-3.374 3.371H3.375zm3.835-1.19a2.181 2.181 0 002.184-2.181A2.186 2.186 0 007.21 1.19H3.46c-1.206 0-2.184.98-2.184 2.187 0 1.206.978 2.18 2.184 2.18z",
    fillRule: "nonzero"
  }))));
}
export default SvgOracleSql;